<!-- START COMPONETNE FILTRI-->
<div class="custom-card">
  <div class="d-flex justify-content-between custom-card-title">
    <button
      class="d-flex justify-content-between accordion-button-custom ps-5 d-xl-none"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#collapseFilter"
      aria-expanded="true"
      aria-controls="collapseFilter"
      (click)="isFilterPanelExpanded = !isFilterPanelExpanded"
    >
      <h5
        class="h5-custom m-0"
        i18n="titolo sezioni filtri|Filtri risultato ricerca @@filtri.expand-menu.title-text"
      >
        Filtri
        <button
        class="button-information mx-2"
        matTooltip="I filtri consentono di selezionare dalla lista di risultati ottenuti quelli che hanno specifiche caratteristicheimpostando il check Si, oppure di selezionare quelli che non la presentano, con il check No.
        I due check sono reciprocamente esclusivi; se non viene selezionato nessuno dei due, non verrà applicata alcuna selezione alla lista di risultati.
        Ogni caratteristica si può riferire al medicinale oppure ad alcune confezioni del medicinale; accanto ad ogni caratteristica è presente il tool tip che descrive lo specifico funzionamento."
        [matTooltipPosition]="'right'"
        matTooltipClass="custom-tooltip"
      >
        <img alt="Informazioni" src="assets/icons/info-circle.svg" />
      </button>
        <span *ngIf="countTrue >= 1" class="badge rounded-pill bg-primary">{{ countTrue }}</span>
      </h5>

      <div>
        <em *ngIf="isFilterPanelExpanded" class="fa fa-chevron-down"></em>
        <em *ngIf="!isFilterPanelExpanded" class="fa fa-chevron-up"></em>
      </div>
    </button>

    <h5
      class="h5-custom mt-5 ms-5 d-none d-xl-block"
      i18n="titolo sezioni filtri|Filtri risultato ricerca @@filtri.title-text"
    >
      Filtri
      <button
      class="button-information ms-2"
      matTooltip="I filtri consentono di selezionare dalla lista di risultati ottenuti quelli che hanno specifiche caratteristiche impostando il check Si, oppure quelli che non la presentano selezionando il check No.
      I due check sono reciprocamente esclusivi; se non viene selezionato nessuno dei due, non verrà applicata alcuna selezione alla lista di risultati.
      Ogni caratteristica si può riferire al medicinale oppure ad alcune confezioni del medicinale; accanto ad ogni caratteristica è presente il tool tip che descrive lo specifico funzionamento."
      [matTooltipPosition]="'right'"
      i18n-matTooltip="@@filtri.title-tooltip"
      matTooltipClass="custom-tooltip"
    >
      <img alt="Informazioni" src="assets/icons/info-circle.svg" />
    </button>
    </h5>
  </div>

  <div
    class="custom-card-body"
    [ngClass]="{ 'collapse': getIsSmallScreen() }"
    id="collapseFilter"
  >

    <app-single-filter
      [filterModel]="filterData.soggettoAPrescrizione"
      [header]="true"
      (changeEvent)="manageFiltersSearch(); emitSearchEvent();"
    >
      <span
        class="span-custom"
        i18n="filtro prescrizione medica|Sezione filtri risultato ricerca @@filtri.text-filter.soggetto-prescrizione-medica-text"
        >Soggetto a prescrizione medica</span>
        <button
          class="button-information ms-2"
          matTooltip="Il check Si seleziona i medicinali con almeno una confezione che richiede una prescrizione medica; il check No seleziona i medicinali con almeno una confezione che non richiede prescrizione medica."
          [matTooltipPosition]="'left'"
          i18n-matTooltip="@@filtri.prescrizione-tooltip"
          matTooltipClass="custom-tooltip"
        >
          <img alt="Informazioni" src="assets/icons/info-circle.svg" />
        </button>
    </app-single-filter>

    <app-single-filter
      [filterModel]="filterData.inCommercio"
      (changeEvent)="manageFiltersSearch(); emitSearchEvent();"
    >
      <span
        class="span-custom"
        i18n="filtro in commercio|Sezione filtri risultato ricerca @@filtri.commercio-text"
        >In Commercio</span>
        <button
          class="button-information  ms-2"
          matTooltip="Il check Si seleziona i medicinali con almeno una confezione già disponibile in commercio; il check No seleziona i medicinali con almeno una confezione non ancora in commercio."
          [matTooltipPosition]="'left'"
          matTooltipClass="custom-tooltip"
          i18n-matTooltip="@@filtri.commercio-tooltip"
          aria-label="Sospeso: consequat a nunc elementum integer non eu sed netus ante. Dui risus dictum turpis commodo risus nunc. Nisl urna sollicitudin nulla eu. Sed at tortor suscipit at."
        >
          <img alt="Informazioni" src="assets/icons/info-circle.svg" />
        </button>
    </app-single-filter>

    <app-single-filter
      [filterModel]="filterData.sospeso"
      (changeEvent)="manageFiltersSearch(); emitSearchEvent();"
    >
      <span
        class="span-custom"
        i18n="filtro sospeso|Sezione filtri risultato ricerca @@filtri.sospeso-text"
        >Sospeso</span>
        <button
          class="button-information ms-2"
          matTooltip="Il check Si seleziona i medicinali con almeno una confezione con provvedimento di divieto di vendita o di dispensazione; il check No seleziona i medicinali con confezioni per le quali non è stato emesso alcun provvedimento."
          [matTooltipPosition]="'left'"
          matTooltipClass="custom-tooltip"
          i18n-matTooltip="@@filtri.sospeso-tooltip"
        >
          <img alt="Informazioni" src="assets/icons/info-circle.svg" />
        </button>
    </app-single-filter>

    <app-single-filter
      [filterModel]="filterData.innovativo"
      (changeEvent)="manageFiltersSearch(); emitSearchEvent();"
    >
      <span
        class="span-custom"
        i18n="filtro innovativo|Sezione filtri risultato ricerca @@filtri.innovativo-text"
        >Innovativo</span>
        <button
          class="button-information ms-2"
          matTooltip="Il check Si seleziona i medicinali considerati Innovativi; il check No seleziona i medicinali non Innovativi."
          [matTooltipPosition]="'left'"
          matTooltipClass="custom-tooltip"
          i18n-matTooltip="@@filtri.innovativo-tooltip"
        >
          <img alt="Informazioni" src="assets/icons/info-circle.svg" />
        </button>
    </app-single-filter>

    <app-single-filter
    [disabled]="disabilitaOrfano"
      [filterModel]="filterData.orfano"
      (changeEvent)="manageFiltersSearch(); emitSearchEvent();"
    >
      <span
        class="span-custom"
        i18n="filtro orfano|Sezione filtri risultato ricerca @@filtri.orfano-text"
        >Orfano</span>
        <button
          class="button-information ms-2"
          matTooltip="Il check Si seleziona i medicinali dichiarati Orfani, ossia utilizzati per la diagnosi, la prevenzione e il trattamento delle malattie rare; il check No seleziona i medicinali non dichiarati Orfani. Se si proviene dall'elenco Orfani della home page, non è consentito modificare questo filtro."
          [matTooltipPosition]="'left'"
          i18n-matTooltip="@@filtri.orfano-tooltip"
          matTooltipClass="custom-tooltip"
        >
          <img alt="Informazioni" src="assets/icons/info-circle.svg" />
        </button>
    </app-single-filter>

    <app-single-filter
      [filterModel]="filterData.pianoTerapeutico"
      (changeEvent)="manageFiltersSearch(); emitSearchEvent();"
    >
      <span
        class="span-custom"
        i18n="filtro piano terapeutico|Sezione filtri risultato ricerca @@filtri.piano-terapeutico-text"
        >Piano Terapeutico</span>
        <button
          class="button-information ms-2"
          matTooltip="Il check Sì seleziona i medicinali con almeno una confezione che richiede un piano terapeutico per essere rimborsate dal SSN; il check No seleziona i medicinali con almeno una confezione che non richiede un piano terapeutico."
          [matTooltipPosition]="'left'"
          i18n-matTooltip="@@filtri.piano-terapeutico-tooltip"
          matTooltipClass="custom-tooltip"
        >
          <img alt="Informazioni" src="assets/icons/info-circle.svg" />
        </button>
    </app-single-filter>

    <app-single-filter
      [filterModel]="filterData.dopante"
      (changeEvent)="manageFiltersSearch(); emitSearchEvent();"
    >
      <span
        class="span-custom"
        i18n="filtro dopante|Sezione filtri risultato ricerca @@filtri.dopante-text"
        >In Lista Doping</span>
        <button
          class="button-information ms-2"
          matTooltip="Il check Si seleziona esclusivamente i medicinali che hanno nella loro composizione sostanze considerate dopanti; il check No seleziona esclusivamente medicinali che nella composizione non hanno sostanze considerate dopanti."
          [matTooltipPosition]="'left'"
          matTooltipClass="custom-tooltip"
          i18n-matTooltip="@@filtri.dopante-tooltip"
        >
          <img alt="Informazioni" src="assets/icons/info-circle.svg" />
        </button>
    </app-single-filter>

    <!-- <app-single-filter
    [disabled]="disabilitaCarenza"
      [filterModel]="filterData.carenza"
      (changeEvent)="manageFiltersSearch(); emitSearchEvent();"
    >
      <span
        class="span-custom"
        i18n="filtro carenza|Sezione filtri risultato ricerca @@filtri.carenza-text"
        >Carenza</span>
        <button
          class="button-information ms-2"
          matTooltip="Il check Sì seleziona i medicinali aventi almeno una confezione carente, ossia in stato di temporanea irreperibilità sul mercato nazionale; il check No seleziona i medicinali aventi almeno una confezione non carente.
          Se si proviene dall'elenco Carenti della home page non è consentito modificare questo filtro."
          i18n-matTooltip="@@filtri.carenza-tooltip"
          [matTooltipPosition]="'left'"
          matTooltipClass="custom-tooltip"
        >
          <img alt="Informazioni" src="assets/icons/info-circle.svg" />
        </button>
    </app-single-filter> -->

  </div>
</div>
<!-- FINE COMPONETNE FILTRI-->
